<template>
  <div>
    <div class="custom-css" style="height: 100%; width: 100%">
      <svg
        preserveAspectRatio="none meet"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        style="height: 100%; width: 100%"
      >
        <g fill="none" :stroke="option.color" :stroke-width="option.lineWidth">
          <path
            :class="classType"
            :stroke-dasharray="dashPattern"
            :d="dWidth"
          ></path>
        </g>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: "avue-echart-VerticalLine",
  props: {
    option: Object,
    component: Object,
  },
  data() {
    return {
    };
  },
  computed: {
    dWidth() {
      if (this.component.width > this.option.lineWidth - 10) {
        return `M${this.component.width / 2} 0  V${this.component.height}`;
      } else {
        return `M0 0 V${this.component.height}`;
      }
    },
    dashPattern() {
      switch (this.option.lineType) {
        case "solid":
          return ""; // 实线
        case "dotted":
          return "5 5"; // 点线
        case "dashed":
          return "10 10"; // 虚线
        case "dashdot":
          return "10 10 2 10"; // 混合线：虚线+点线
        default:
          return ""; // 默认实线
      }
    },
    classType(){
      if(this.option.lineType == 'solid' || this.option.lineAnimation == ''){
        return ''
      }
      return this.option.lineFlow == 'positive' ? `animation-positive-${this.option.lineType}`:`animation-reverse-${this.option.lineType}`; 
    }
  },
};
</script>

<style scoped>
 @import url("../index.css");
</style>